import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Heading, Text } from "@cinch-labs/design-system";
import { FeatureCard } from "./feature-card/feature-card";
import styles from "./feature-section.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
export var FeatureSection = function(param) {
    var title = param.title, body = param.body, cards = param.cards;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        backgroundColor: "#F2F5FF",
        className: {
            container: styles.container,
            inner: styles.inner
        },
        isFluid: true,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cards,
                children: Array.isArray(cards) && cards.length >= 3 && cards.map(function(card) {
                    return /*#__PURE__*/ _createElement(FeatureCard, _object_spread_props(_object_spread({}, card), {
                        key: card.title
                    }));
                })
            })
        ]
    });
};
